// load.js  —— Vite 兼容版
// 说明：eager:true 等价于一次性载入所有 JSON，和 require.context 的行为更接近
const modules = import.meta.glob('./locales/*/*.json', {
    eager: true,
    import: 'default',
});

const i18nConfig = {};
const lansSet = new Set();
const namespacesSet = new Set();

for (const path in modules) {
    // path 形如: "./locales/common/zh.json"
    const parts = path.split('/');
    const name = parts[parts.length - 2]; // namespace
    const lan = parts[parts.length - 1].replace(/\.json$/, ''); // zh / en …
    const data = modules[path]; // 该 JSON 的默认导出对象

    if (!i18nConfig[lan]) i18nConfig[lan] = {};
    i18nConfig[lan][name] = data;

    lansSet.add(lan);
    namespacesSet.add(name);
}

export const resources = i18nConfig;
export const lans = [...lansSet];
export const namespaces = [...namespacesSet];
export default { lans, resources, namespaces };
